import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PublicNavbarComponent } from './public-navbar.component';

@NgModule({
  declarations: [
    PublicNavbarComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
  ],
  exports: [PublicNavbarComponent],
})
export class PublicNavbarModule {}
